export default __webpack_public_path__ + "pgnv-assets/c5221bcd2766bdd8270831c0152cc84e.png";